import React from 'react';
import './NavActions.scss';
import SearchBar from '../../../components/SearchBar/SearchBar';
import Cart from '../Cart/Cart';
import Wishlist from '../Wishlist/Wishlist';
import UserMenu from '../UserMenu/UserMenu';
import BookEyeTest from '../BookEyeTest/BookEyeTest';

const NavActions = props => {
  return (
    <div className="odNavActions">
      <BookEyeTest />
      <UserMenu />
      <SearchBar
        {...props}
        placeholder="Search"
        setShowBookEyeTest={() => {}}
        triggerDataLayerOnCtaClick={() => {}}
      />
      <Wishlist />
      <Cart />
    </div>
  );
};

export default NavActions;
